
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13 13C12.44 13.56 11.55 13.56 11 13.01V13C10.45 12.45 10.45 11.56 11 11.01V11C11.55 10.45 12.44 10.45 12.99 11H13C13.55 11.55 13.55 12.45 13 13ZM12 5.99999L14.12 8.11999L16.62 5.61999L13.42 2.41999C12.64 1.63999 11.37 1.63999 10.59 2.41999L7.39001 5.61999L9.89001 8.11999L12 5.99999ZM6.00001 12L8.12001 9.87999L5.62001 7.37999L2.42001 10.58C1.64001 11.36 1.64001 12.63 2.42001 13.41L5.62001 16.61L8.12001 14.11L6.00001 12ZM18 12L15.88 14.12L18.38 16.62L21.58 13.42C22.36 12.64 22.36 11.37 21.58 10.59L18.38 7.38999L15.88 9.88999L18 12ZM12 18L9.88001 15.88L7.38001 18.38L10.58 21.58C11.36 22.36 12.63 22.36 13.41 21.58L16.61 18.38L14.11 15.88L12 18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-api`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconApi

    ```js
    <b-new-b-icon-api />
    ```
</docs>


